import React from "react";
import "./AboutUs.css";
import { FaHandshake, FaGlobe, FaRocket, FaUsers } from "react-icons/fa";

const AboutUs = () => {
  return (
    <section className="aboutUs">

      {/* Hero */}
      <div className="aboutUs-hero catchy-hero">
        <div className="hero-left aboutUs-animate-slide">
          <h1>About Us</h1>
          <p>
            Welcome to Abasinexpress, your premier B2B travel portal dedicated to transforming the way businesses navigate the world of travel. 
            At Abasinexpress, we understand the unique needs of the travel industry and are committed to providing tailored solutions that empower businesses to thrive.
          </p>
          <a href="https://flyabasin.com/" target="_blank" rel="noopener noreferrer" ><div className="hero-badge">✨ The Best B2B Travel Portal</div></a>
        </div>

        <div className="hero-right aboutUs-animate-fade">
          <img src="/Images/aboutus.jpeg" alt="Travel Business" />
        </div>

        {/* Subtle background accent */}
        <div className="hero-accent accent1"></div>
        <div className="hero-accent accent2"></div>
      </div>

      {/* Mission / Vision */}
      <div className="aboutUs-section aboutUs-mission-section">
        <div className="aboutUs-mission-left aboutUs-animate-fade">
          <img
            src="https://www.unionchristianschool.com/wp-content/uploads/2023/03/Vision-Mission.png"
            alt="Mission"
          />
        </div>
        <div className="aboutUs-mission-right aboutUs-animate-slide">
          <h2>Our Mission</h2>
          <p>
            At Abasinexpress, our mission is to simplify and elevate the travel experience for our B2B partners. 
            We strive to be the preferred travel portal by delivering cutting-edge technology, unparalleled service, and strategic partnerships that drive business success.
          </p>
          <p>
            <strong>Empowering Business Success:</strong> We are dedicated to empowering the success of our B2B partners by providing them with a dynamic platform 
            that seamlessly integrates advanced technology, strategic partnerships, and industry insights. 
            Our mission is to be the driving force behind the growth and profitability of businesses in the travel sector.
          </p>
        </div>
      </div>

      {/* Core Values */}
      <div className="aboutUs-section aboutUs-values">
        <h2 className="aboutUs-section-title aboutUs-animate-fade">Our Core Values</h2>
        <div className="aboutUs-cards">
          <div className="aboutUs-card aboutUs-animate-bounce">
            <FaHandshake className="aboutUs-icon" />
            <h3>Partnership</h3>
            <p>Building long-term relationships with travel businesses through trust and collaboration.</p>
          </div>
          <div className="aboutUs-card aboutUs-animate-bounce-delay">
            <FaGlobe className="aboutUs-icon" />
            <h3>Innovation</h3>
            <p>Leveraging cutting-edge technology to simplify and elevate the B2B travel experience.</p>
          </div>
          <div className="aboutUs-card aboutUs-animate-bounce-delay2">
            <FaRocket className="aboutUs-icon" />
            <h3>Growth</h3>
            <p>Driving profitability and expansion for our partners in the dynamic travel sector.</p>
          </div>
          <div className="aboutUs-card aboutUs-animate-bounce-delay3">
            <FaUsers className="aboutUs-icon" />
            <h3>Customer Success</h3>
            <p>Prioritizing the success of our B2B clients with personalized support and guidance.</p>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="aboutUs-cta aboutUs-animate-fade"> 
        <h2>Ready to grow your travel business with us?</h2> 
        <a href="tel:+93779897682">
          <button className="aboutUs-btn">Contact Our Sales Team</button>
        </a>
      </div>

    </section>
  );
};

export default AboutUs;
